
import { Alert, Avatar, Box, Button, CardMedia, Paper, Snackbar, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, TextField, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react'
import { v4 as uuidv4 } from "uuid";
//import fondo from '../../../Web Mundo/fondo_noche.png'
import botonRetiro from '../../../Web Mundo/boton1.png'
import deposit_bone from '../../../Web Mundo/deposit_bone.png'
import withdraw_bone from '../../../Web Mundo/withdraw_bone.png'
import axios from 'axios';
import { getCookie } from '../../../utils/getCookie';
import { rutas } from '../../../rutas/rutas';
import { useSelector } from 'react-redux';
import fondo from '../../../Web Mundo/FONDO_NEW_STAKE_fcheju.png'
//const fondo = 'https://res.cloudinary.com/dbav8xw6s/image/upload/f_auto,q_23/v1669377771/FONDOS%20NAVIDE%C3%91OS/Fondo_navidad_1_znbszd.png'
// 'https://res.cloudinary.com/dbav8xw6s/image/upload/f_auto,q_26/v1669377765/FONDOS%20NAVIDE%C3%91OS/fondo_navidad_vhwqjk.png'

const columns = [
    { id: 'usuario', label: 'users', minWidth: 120 },
    { id: 'posicion', label: 'position', minWidth: 100 },
    { id: 'puntaje', label: 'hueso', minWidth: 100 },
 
  ];

export const Stake = () => {
  const {informacion: {dineroReal}} = useSelector(state=> state.userSlice)

    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [rows, setRows] = useState([])
    const [usuario, setUsuario ] = useState({})
    const [ input, setInput ] = useState(0)
    const [ acumulador, setAcumulador ] = useState(0)
    const [ ticket, setTicket ] = useState(0)
    const [ disponible, setDisponible ] = useState(0)
    const [ cantidad, setCantidad ] = useState(0)
    const [open, setOpen] = useState(false);
    const [error, setError] = useState(false)
    const [errorText, setErrorText] = useState("Error");
    
    const handleClose = (event, reason) => {
      if (reason === 'clickaway') {
        return;
      }
  
      setOpen(false);
    };
    const handleChange = (e)=> setCantidad(e.target.value)
    const handleChangePage = (event, newPage) => {
        setPage(newPage);
      };
      const handleRetiroTicket = ()=>{
        const tokenJWT = getCookie('token')
        axios.get(rutas.retirarTicket, { headers: {'token': tokenJWT}}).then(res=>{
            //dispatch(setInformacion({...res.data?.usu}));
           // handleMirar()
            setOpen(true)
            setError(false)
        }).catch(error=> {
          setErrorText(error?.response?.data?.error)
          setOpen(true)
          setError(true)
        })
    }
    const handleRetiroTodo = ()=>{
        const tokenJWT = getCookie('token')
        axios.get(rutas.retiroStake, { headers: {'token': tokenJWT}}).then(res=>{
         // handleMirar()
          setOpen(true)
          setError(false)
          // dispatch(setInformacion({...res.data?.usu}));
        }).catch(err=> {
          setOpen(true)
          setError(true)
        })
    }
      const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(event.target.value);
        setPage(0);
      };
      const deposito =()=>{
        const tokenJWT = getCookie('token')
      
       if(cantidad <= 0 || cantidad > dineroReal) {
      
        setOpen(true)
        setError(true)
        return 
      }
        axios({
          method: 'post',
          url: rutas.stakeIngreso,
          headers:  {
            'token': tokenJWT,
            'Content-Type': 'application/json'},
          data: {
            cantidad: cantidad
          }
        }).then(res=>{
          handleMirar()
          setOpen(true)
          setError(false)
        }).catch(err=> {
 
          setOpen(true)
          setError(true)
        })
      
    }
    const handleMirar = ()=>{
      const tokenJWT = getCookie('token')
      axios.get(rutas.mirarStake, { headers: {'token': tokenJWT}}).then(res=>{
        if(res.data?.stake){
          let conteo = 0
          const row = res.data.stake.map(({nombre: usuario, posicion, cantidad: puntaje, avatar = "" }) => {
           conteo += puntaje
            return {
              usuario,
              posicion,
              puntaje, 
              avatar 
            }
          })
         
          setDisponible(res.data.disponible?.cantidad)
          setTicket(res.data.ticket?.cantidad)
          setAcumulador(conteo)
          setUsuario(res.data.userStake)
          setRows(row)
        }
      })
    }

    useEffect(() => {
        //const tokenJWT = document.cookie.replace('token=', '')
        handleMirar()
      }, [])
  return (
    <Box sx={{ backgroundOrigin: "content-box", backgroundSize:"contain",backgroundImage: `url(https://res.cloudinary.com/druu0mcam/image/upload/v1719339319/Dise%C3%B1o_sin_t%C3%ADtulo_56_htku49_qnv3i1.png)`, display:'flex', flexDirection: {xs: 'column', md: 'row'}, justifyContent:'right',alignItems: 'center', width: '100%', height: {xs: '100%', md: '93vh'}, backgroundPosition: 'bottom', backgroundSize: 'cover'}}>
    <Paper  sx={{ width: {xs: '95%', md: '38%'}, height:{xs: '40%', md:  '80%'}, backgroundColor: 'rgba(255, 255, 255, 0.1)' }}>
        <Paper sx={{ width: '100%', overflow: 'hidden', height: '100%',background:'rgba(255, 255, 255, 0.1)'}}>
      <TableContainer sx={{backgroundColor: 'rgba(255, 255, 255, 0.1)' ,  height: '90%',  "&::-webkit-scrollbar": {
          display: "none",
        } }}>
        <Table sx={{backgroundColor: 'rgba(255, 255, 255, 0.1)'}} stickyHeader aria-label="sticky table">
          <TableHead>
            <TableRow>
              {columns.map((column) => (
                <TableCell
                  key={uuidv4()}
                  align={column.align}
                  style={{  background: "#0E1314", color: 'white'}}
                >
                  {column.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {rows
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((row) => {
                return (
                  <TableRow hover role="checkbox" tabIndex={-1}  key={uuidv4()}>
                    {columns.map((column) => {
                      const value = row[column.id];
                      return (
                        <TableCell key={column.id} align={column.align}  style={{  background: "#1E292B", color: 'white'}}  >

                          {
     value
                          }
                        </TableCell>
                      );
                    })}
                  </TableRow>
                );
              })}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[10, 25, 100]}
        component="div"
        count={rows.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
        sx={{height: '35px', display: {xs: 'none', md: 'block'}}}
      />
    </Paper>
        </Paper>
        <Paper  sx={{ width: {xs: '95%', md: '58%'}, height:{xs: '40%', md:  '90%'}, backgroundColor: 'rgba(255, 255, 255, 0.1)' }}>
            <Box sx={{width: '100%', height: '100%' ,flexDirection: 'column',display:'flex', justifyContent: 'center', alignItems: 'center'}}>

        
            <Typography sx={{fontSize: '1.5rem', m: 1, textAlign: 'left', textShadow: `blue 1px 0 10px`, fontWeight: '800'}}><a  target="_blank" href='https://peakd.com/hive-131619/@bigdogbone/how-does-the-stake-of-the-bone-token-work-in-the-big-dog-bone-game-to-get-a-reward-ticket'>How does it work ? </a></Typography>
            <Typography sx={{fontSize: '1.5rem',m: 1, textAlign: 'left', textShadow: `blue 1px 0 10px`, fontWeight: '800'}}>Weekly Pool - {ticket}</Typography>
            <Typography sx={{fontSize: '1.5rem' ,m: 1, textAlign: 'left', textShadow: `blue 1px 0 10px`, fontWeight: '800'}}>Ticket available to claim  - {disponible > 0 ? String(disponible).substring(0,6) : 0}</Typography>
            <Typography variant='h5' sx={{ m: 1, textAlign: 'left', textShadow: `blue 1px 0 10px`, fontWeight: '800'}}>{'Participation in the Pool'}: {usuario?.cantidad > 0 ? String((usuario?.cantidad / acumulador) * 100 ).substring(0,6) : 0} % - {usuario?.cantidad === undefined  ? 0 : String((usuario?.cantidad / acumulador )*ticket  ).substring(0,6)}</Typography>
            <CardMedia
        component="img"
        sx={{ width: '280px', cursor:'pointer'}}
        image={botonRetiro}
        alt="P"
        onClick={handleRetiroTicket}
      />
              <TextField onChange={handleChange} type="number" sx={{border: '1px solid white', width: '280px'}} id="outlined-basic" label="Deposit" variant="filled" />

                <CardMedia
                onClick={deposito}
        component="img"
        sx={{ width: '280px', cursor: 'pointer'}}
        image={deposit_bone}
        alt="P"
      />
                <CardMedia
        component="img"
        sx={{ width: '280px', cursor: 'pointer'}}
        image={withdraw_bone}
        alt="P"
        onClick={handleRetiroTodo}
      />
          </Box>



          <Stack spacing={2} sx={{ width: "100%" }}>
          <Snackbar open={open} autoHideDuration={6000} onClose={handleClose}>
            {
              error ?
              <Alert
              onClose={handleClose}
              severity="error"
              sx={{ width: "100%" }}
              variant="filled"
            >
             {errorText}
            </Alert>
            :
            <Alert
            onClose={handleClose}
            severity="success"
            sx={{ width: "100%" }}
            variant="filled"
          >
           Succes
          </Alert>
            }
          </Snackbar>
        </Stack>
        </Paper>
       
    </Box>
  )
}
